import { watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";

export default function useCheckAgeVerification() {
  const { authUser } = useAuthUser();
  const { nSFWUserSettings } = useNSFWUserSettings();

  const checkNeedShowConfirm = async () => {
    if (!authUser.value) return;
    const showSetup = !config.featureNSFW ? false : nSFWUserSettings.value === null;
    showSetup && emitter.emit(EVENTS.AGE_VERIFICATION_START);
  };

  watch(authUser, checkNeedShowConfirm);

  return {
    checkNeedShowConfirm,
  };
}
